// src/components/common/IconResetButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@/icons';
import './IconResetButton.css';

interface IconResetButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  className?: string;
}

const IconResetButton: React.FC<IconResetButtonProps> = ({
  onClick,
  title,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      className={`icon-reset-button ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faArrowsRotate} />
    </button>
  );
};

export default IconResetButton;
